export default __webpack_public_path__ + "static/media/magazine.c0108b80.svg";